$(document).ready(function () {
  if (document.querySelector('.timer')) {
    let item = $('.timer');

    setInterval(function time() {
      var d = new Date();
      var hours = 23 - d.getHours();
      if ((hours + '').length == 1) {
        hours = '0' + hours;
      }
      var min = 59 - d.getMinutes();
      if ((min + '').length == 1) {
        min = '0' + min;
      }
      var sec = 59 - d.getSeconds();
      if ((sec + '').length == 1) {
        sec = '0' + sec;
      }

      let html = `<div class="timer-processed">
                        <span id="hours" class="timer-item">
                            <span>${hours}</span>
                        </span>
                        <span class="delimiter">:</span>
                        <span id="minutes" class="timer-item">
                            <span>${min}</span>
                        </span>
                        <span class="delimiter">:</span>
                        <span id="seconds" class="timer-item">
                            <span>${sec}</span>
                        </span>
                    </div>`;
      $(item).html(html);
    }, 1000);
  }

});


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/counter.js